// extracted by mini-css-extract-plugin
export default {"container":"SuccessNotice_container__z709C","check":"SuccessNotice_check__koqwN"};